import styled from "styled-components";

export type Variante = "aprovado" | "reprovado" | "atencao";

const VARIANTE_CORES: Record<Variante, { texto: string; fundo: string }> = {
  aprovado: { texto: "#4CAF50", fundo: "#E8F5E9" },
  reprovado: { texto: "#F43636", fundo: "#FFF0F0" },
  atencao: { texto: "#ED6C02", fundo: "#FFF4E5" },
};

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 24px;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Title = styled.h1`
  font-family: Inter;
  font-size: 18px;
  font-weight: 600;
  line-height: 21.78px;
  letter-spacing: -0.01em;
  color: #333333;
`;

export const BodyContainer = styled.div`
  width: 100%;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-top: 12px;
  overflow: hidden;
`;

export const ItemRow = styled.div`
  display: flex;
  align-items: stretch;
  border-bottom: 1px solid #e0e0e0;

  &:last-child {
    border-bottom: none;
  }
`;

export const ItemLabel = styled.div<{ destaque?: boolean }>`
  flex: 1;
  display: flex;
  align-items: center;
  padding: 12px 16px;
  font-family: Inter;
  font-size: 14px;
  font-weight: ${({ destaque }) => (destaque ? 600 : 400)};
  letter-spacing: -0.01em;
  color: #424248;
  background-color: #ffffff;
`;

export const ItemValue = styled.div<{ variante: Variante; destaque?: boolean }>`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 12px 16px;
  font-family: Inter;
  font-size: 14px;
  font-weight: ${({ destaque }) => (destaque ? 600 : 500)};
  letter-spacing: -0.01em;
  color: ${({ variante }) => VARIANTE_CORES[variante].texto};
  background-color: ${({ variante }) => VARIANTE_CORES[variante].fundo};
`;

export const EmptyMessage = styled.div`
  padding: 16px;
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  color: #6b7280;
  background-color: #ffffff;
`;
